/**
 * Included into the header of pages.
 */

// JQuery - Provide our own in place of what WordPress ships with. In functions.php we also dequeue the built in jquery
import './lib/JQueryGlobal';

// bundle fancybox to remove CDN links from base.twig
import './component/Fancybox';

 // Animations
 import SiteAnimations from './component/SiteAnimations';
 SiteAnimations.createInstance([
     {
         observedSelector: '.masthead__inner',
         options: {
             rootMargin: '0px 0px',
             threshold: 0
         }
     },
     {
         observedSelector: '.cardListingGroup, .introContent, .officeContent__aside, .testimonialIntro, div[data-slider-var], .stepListingGroup, .stepListingGroupAlt, .responsiveGraphic, .contentGroup, .contentWithAside__inner',
         options: {
             rootMargin: '-50px 0px',
             threshold: 0
         }
     },
     {
         observedSelector: '.richContent__inner, .cta, .comparisonListing, .listItemGroup, .childListingGroup, .imageListingGroup, .featuredListingGroup, .stateSearch__inner',
         options: {
             rootMargin: '-100px 0px',
             threshold: 0
         }
     }
 ]);